import React from 'react';
import { Link } from 'react-router-dom';
import { Button, EmptyContent } from '@/components/ui';
import ErrorLayout from '@/components/ErrorLayout';
import { IconFileSearch } from '@tabler/icons-react';

export const NotFoundPage: React.FC = () => {
  return (
    <ErrorLayout>
      <EmptyContent
        state="error"
        title="Page Not Found"
        description="Sorry, the page you are looking for does not exist or has been moved."
        icon={<IconFileSearch />}
        withIconBox
      >
        <Button as={Link} to="/" variant="classic" color="secondary">
          Go Home
        </Button>
      </EmptyContent>
    </ErrorLayout>
  );
};
